import React from 'react'
import { observer } from 'mobx-react'
import ResponsesCard from '../ResponsesCard'
import JobViewModel from '../JobViewModel'
import InfoLinesCard from '../InfoLinesCard'
import EventsCard from '../EventsCard'
import DocumentsCard from '../DocumentsCard'
import styles from './DetailsView.sass'
import AmendmentsCard from '../AmendmentsCard'
import MilestonesCard from '../MilestonesCard'
import CapturedInformationCard from '../CapturedInformationCard'
import JobScopeChangeRequestsCard from '../JobScopeChangeRequestsCard'
import { useDocumentTitle } from '../../../../../hooks/document-title'
import TxfJobCard from '../TxfJobCard'

interface Props {
  vm: JobViewModel
}

export default observer(function DetailsView({ vm }: Props) {
  return vm.showDraftView ? <DraftView vm={vm} /> : <JobView vm={vm} />
})

const DraftView = observer(function DraftView({ vm }: Props) {
  return (
    <div className={styles.root}>
      {vm.detailsVM.canViewCapturedInfoCard && (
        <CapturedInformationCard vm={vm} />
      )}

      {vm.canViewDocs && <DocumentsCard vm={vm} />}
      {vm.canViewAmendments && <AmendmentsCard vm={vm} />}
    </div>
  )
})

const JobView = observer(function JobView({ vm }: Props) {
  useDocumentTitle(`${vm.job.workspace.name} | ${vm.job.displayName}`)

  return (
    <div className={styles.root}>
      <div className={styles.onboardingWrapper}>
        {vm.detailsVM.canViewCapturedInfoCard ? (
          <CapturedInformationCard vm={vm} />
        ) : (
          <ResponsesCard vm={vm} />
        )}
      </div>

      <DocumentationSection vm={vm} />

      {vm.job.infoLines.length > 0 && <InfoLinesCard vm={vm} />}

      {vm.canViewAmendments && <AmendmentsCard vm={vm} />}

      {vm.canViewScopeChangeRequests &&
        vm.scopeChangeRequests.length > 0 &&
        !vm.showDraftView && <JobScopeChangeRequestsCard vm={vm} />}

      <EventsCard vm={vm} />

      {vm.milestonesVM.milestones.length > 0 &&
        !vm.showDraftView &&
        !vm.isProgressionFlowEnabled && <MilestonesCard vm={vm} />}
    </div>
  )
})

const DocumentationSection = observer(function DocumentationSection({
  vm,
}: Props) {
  if (vm.txfJobViewModel.canView && vm.canViewDocs) {
    // The wrapping div allows to have a stacked layout for this section within the
    // grid layout of the details page. Otherwise they would place next to each other
    // horizontally which isn't desired.
    return (
      <div className={styles.txfDocumentationWrapper}>
        {vm.txfJobViewModel.canView && <TxfJobCard vm={vm.txfJobViewModel} />}
        {vm.canViewDocs && <DocumentsCard vm={vm} />}
      </div>
    )
  }

  if (vm.txfJobViewModel.canView) {
    return <TxfJobCard vm={vm.txfJobViewModel} />
  }

  if (vm.canViewDocs) {
    return <DocumentsCard vm={vm} />
  }
})
